import {useAuthAxios} from 'hooks/api/useAuthAxios'
import {useFileDownload} from 'hooks/api/useFileDownload'

export const useDownloadUploadedDocument = () => {
  const authAxios = useAuthAxios()
  const {download} = useFileDownload()

  return async (documentId: string) => {
    const path = `/api/uploaded_documents/${documentId}`
    const getter = () => authAxios.get(path, {responseType: 'arraybuffer'})

    download(getter)
  }
}
